
import hash from './hasher.js';

const defaultState = Object.freeze({
        hashInput: "",
        hashInputFile: "",
        hashOutput: "",
        hashType: "SHA256",
        hashOutputType: "color",
    });

export default function hashReducer(state = defaultState, action = {type:'NO-OP'}) {
    switch( action.type ) {
        case 'HASH-INPUT-CHANGE':
            return changeInput(state, action);
        case 'HASH-TYPE-CHANGE':
            return changeHashType(state, action);
        case 'HASH-OUTPUT-TYPE-CHANGE':
            return changeOutputType(state, action);
        case 'HASH-INPUT-FILE-CHANGE':
            return selectedFile(state, action);
        default:
            return state;
    }
}

function changeInput(state, action) {
    const newVal = typeof action.value === 'string' ? action.value : state.hashInput;
    const toHash = newVal || state.hashInputFile || "";
    return {
        ...state,
        hashInput: newVal,
        hashOutput: toHash ? hash(toHash, state.hashType) : "",
    };
}

function changeHashType(state, action) {
    if( !action || !action.newType || state.hashType === action.newType ) {
        return state;
    }
    const toHash = state.hashInput || state.hashInputFile || "";
    return {
        ...state,
        hashType: action.newType,
        hashOutput: toHash ? hash(toHash, action.newType) : "",
    };
}

function changeOutputType(state, action) {
    if( !action || !action.newType || state.hashType === action.newType ) {
        return state;
    }
    return {
        ...state,
        hashOutputType: action.newType,
    };
}

function selectedFile(state, action) {
    if( !action || !action.contents ) {
        return state;
    }
    return {
        ...state,
        hashInput: "",
        hashInputFile: action.contents,
        hashOutput: hash(action.contents),
    };
}






// WEBPACK FOOTER //
// ./src/reducers/hash-reducer.js